import * as XLSX from 'xlsx';
import { exportWorkOrderPdf as exportWorkOrderPdfBlob } from '../api/work-orderAPI';

export const generateCsv = (workOrders = []) => {
  const headers = [
    'Number',
    'Title',
    'Compliance',
    'Status',
    'Priority',
    'Task Type',
    'Asset or Area',
    'Team',
    'Scheduled At',
  ];

  const rows = workOrders.map(row => [
    row.workOrderNumber || '',
    row.workOrderTitle || '',
    row.statutory === 1 ? 'Yes' : 'No',
    row.status?.name || '',
    row.priority?.name || '',
    row.taskType?.taskTypeName || '',
    row.assetId
      ? `${row.asset?.assetNumber || ''} - ${row.asset?.assetDescription || ''}`
      : row.areaId
        ? `${row.area?.code || ''} - ${row.area?.name || ''}`
        : '',
    row.team?.teamName || '',
    row.scheduledAt ? row.scheduledAt.slice(0, 10) : '',
  ]);

  const csvLines = [
    headers.join(','),
    ...rows.map(r => r.map(v => `"${String(v ?? '').replace(/"/g, '""')}"`).join(',')),
  ];
  return csvLines.join('\n');
};

export const handleExportExcel = (workOrders = []) => {
  const headers = [
    'Number',
    'Title',
    'Compliance',
    'Status',
    'Priority',
    'Task Type',
    'Asset or Area',
    'Team',
    'Scheduled At',
  ];

  const rows = workOrders.map(row => [
    row.workOrderNumber || '',
    row.workOrderTitle || '',
    row.statutory === 1 ? 'Yes' : 'No',
    row.status?.name || '',
    row.priority?.name || '',
    row.taskType?.taskTypeName || '',
    row.assetId
      ? `${row.asset?.assetNumber || ''} - ${row.asset?.assetDescription || ''}`
      : row.areaId
        ? `${row.area?.code || ''} - ${row.area?.name || ''}`
        : '',
    row.team?.teamName || '',
    row.scheduledAt ? row.scheduledAt.slice(0, 10) : '',
  ]);

  const worksheetData = [headers, ...rows];
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'WorkOrders');
  const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([wbout], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'workorders.xlsx';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const handleExportCSV = (workOrders = []) => {
  const csv = generateCsv(workOrders);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'workorders.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const handleExportPdf = async (selectedWorkOrder) => {
  if (!selectedWorkOrder?.id) return;

  const pdfBlob = await exportWorkOrderPdfBlob(selectedWorkOrder.id);
  const blobUrl = URL.createObjectURL(pdfBlob);

  const downloadLink = document.createElement('a');
  downloadLink.href = blobUrl;
  downloadLink.download = `work_order_${selectedWorkOrder.workOrderNumber || selectedWorkOrder.id}.pdf`;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);

  setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
};

export default {
  generateCsv,
  handleExportExcel,
  handleExportCSV,
  handleExportPdf,
};
